import { NgModule } from 'angular-ts-decorators';
import { TranslationsProvider } from '@core/app/scripts/services/translations';

require('@core/app/scripts/app');

require('../styles/app.scss');

import { components } from './components';
import { services } from './services';

/**
 * Main module of the application.
 */
@NgModule({
  id: 'loginApp',
  declarations: components,
  providers: services,
  imports: ['coreModule'],
})
export class LoginApp {
  static config(
    $routeProvider: ng.route.IRouteProvider,
    translationsProvider: TranslationsProvider,
  ) {
    'ngInject';

    $routeProvider
      .when('/login/:redirect*?', {
        template: '<login></login>',
      })
      .otherwise({
        redirectTo: '/login',
      });

    // supported i18n list
    translationsProvider.translations(
      'nl-nl',
      require('../translations/nl-nl.json'),
    );
    translationsProvider.translations(
      'en-gb',
      require('../translations/en-gb.json'),
    );
    translationsProvider.translations(
      'fr-fr',
      require('../translations/fr-fr.json'),
    );
    translationsProvider.translations(
      'de-de',
      require('../translations/de-de.json'),
    );
    translationsProvider.translations(
      'it-it',
      require('../translations/it-it.json'),
    );
    translationsProvider.translations(
      'es-es',
      require('../translations/es-es.json'),
    );
  }
}
